export default __webpack_public_path__ + "static/media/home-decor-img-12.d7a77f08.png";